exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-box[data-v-66d5ed17]{padding:15px;background:#eceff1;border-radius:6px}", ""]);

// exports
